import { CollectionTemplateDefinitionView } from '@indigohive/cogfy-types'
import clsx from 'clsx'

export type CollectionTemplateTableViewsProps = {
  activeView: CollectionTemplateDefinitionView | undefined
  views: CollectionTemplateDefinitionView[] | undefined
  setActiveView: React.Dispatch<React.SetStateAction<CollectionTemplateDefinitionView | undefined>>
}

export function CollectionTemplateTableViews (props: CollectionTemplateTableViewsProps) {
  const { activeView, views, setActiveView } = props

  return (
    <>
      <div className="flex pt-1 border-b border-neutral/40">
        {views?.map(view => (
          <div
            key={view.id}
            className={clsx(
              'text-sm px-4 py-1 w-fit cursor-pointer',
              activeView?.id === view.id && 'border-b-2 border-black manrope-bold'
            )}
            onClick={() => setActiveView(view)}
          >
            {view?.name ?? 'Untitled'}
          </div>
        ))}
      </div>
    </>
  )
}
